import { Box, Grid, IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@mui/material'; import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { getGeneratedReports, deleteGeneratedReport, getGeneretedReportDownload } from '../../actions/Users/authenticateUsageReports';
import './generatedReports.css';
import { useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import { JsonDataTooltip } from '../JSONTooltip/JsonTooltip';
import { toast } from 'react-toastify';
import { convertDateTimeIntoTimezone, getDecodeURI, getEncodedURI } from '../../utils/util';
import { Delete } from '@material-ui/icons';
import { DeleteReportConfirmationDialog } from './ConfirmDeleteReports';
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import { MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from '../../utils/constants';
import { GeneratedReport, GeneratedReportsProps } from './types';
import SortArrows, { SortOrder } from "../SortArrows";
import { Pagination } from '../Pagination';

const ENTER_KEY_CODE = 'Enter';

const HEADERS=[
    {
      label:'Requested At',
      is_sort:false
    },
    {
      label:'Generated At',
      is_sort:false
    },
    {
      label:'Metadata',
      is_sort:false
    },
    {
      label:'Status',
      is_sort:false
    },
    {
      label:'Report Type',
      is_sort:false
    },
    {
      label:'Summary',
      is_sort:false
    },
    {
      label:'Flow Report',
      is_sort:false
    },
    {
      label:'Actions',
      is_sort:false
    }
  ]

const GeneratedReports = (props: GeneratedReportsProps) => {
    const { authReducer, reports, total_count, history, location, getGeneratedReports, deleteGeneratedReport, getGeneretedReportDownload } = props;

    let _q = new Map<string, string>(Object.entries(getDecodeURI(location.search)));

    const [toDeleteReport, setToDeleteReport] = useState<GeneratedReport | null>(null);
    const [searchValue, setSearchValue] = useState('');
    const [tableParams, setTableParams] = useState<{
        page: number;
        size: number;
        sortBy: string;
        sortOrder: SortOrder;
        search: string;
    }>({
        page: _q.has('page') ? parseInt(_q.get('page') as string) : 1,
        size: _q.has('size') ? parseInt(_q.get('size') as string) : 10,
        sortBy: _q.has('sortBy') ? _q.get('sortBy') as string : 'created_at',
        sortOrder: _q.has('sortOrder') ? _q.get('sortOrder') as SortOrder : 'desc',
        search: _q.has('search') ? _q.get('search') as string : '',
    });
    const searchTimeoutRef = useRef<any>();


    useEffect(() => {
        let params: any = getDecodeURI(location?.search);
        delete params.reportsTab;
        history.push({ pathname: location.url, search: `?${getEncodedURI(params)}` });
    }, [])

    useEffect(() => {
        if (!_.isEmpty(authReducer.selectedOu) && authReducer.selectedOu.hasOwnProperty("id") && authReducer.selectedOu.id) {
            const dpId = authReducer?.selectedOu?.id;
            getGeneratedReports({
                dpId: dpId,
                page: tableParams.page,
                size: tableParams.size,
                search: tableParams.search,
                sort_by: tableParams.sortBy,
                sort_order: tableParams.sortOrder
            })
        }
    }, [authReducer.selectedOu, tableParams])


    const handleDownloadReport = async (report: GeneratedReport, detailed: boolean) => {
        const storagePath = detailed ? report.detailed_report_storage_path : report.summary_report_storage_path;
        const resp = await getGeneretedReportDownload({
            dpId: report.org_id,
            id: report.id,
            detailed_report: detailed,
            storage_path: storagePath
        });
        if (resp && resp.blob) {
            const url = URL.createObjectURL(resp.blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = resp.filename;
            anchor.style.display = 'none';
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            URL.revokeObjectURL(url);
        } else {
            toast.error('Something went wrong, unable to download the file..', {
                position: toast.POSITION.BOTTOM_LEFT,
            });
        }
    }

    const rowsOption = [10, 15, 25, 50, 100];

    const handleChangePage = (event: any, newPage: number) => {
        setTableParams({ ...tableParams, page: newPage });
    };

    const handleChangeSize = (event: any) => {
        setTableParams({ ...tableParams, size: event.target.value, page: 1 });
    };

    const handleDelete = (row: GeneratedReport) => {
        setToDeleteReport(row)
    }

    const handleDeleteCancel = () => {
        setToDeleteReport(null);
    }

    const handleDeleteConfirm = async () => {
        if (toDeleteReport) {
            let _toDeleteReport = toDeleteReport;
            setToDeleteReport(null);
            await deleteGeneratedReport(_toDeleteReport.org_id, _toDeleteReport.id);
            setTableParams({
                ...tableParams,
                page: tableParams.page
            });
        }
    }

    const searchBoxKeyDown = (event: any) => {
        if (event && event.key === ENTER_KEY_CODE) {
            handleSearch(searchValue);
        }
    }

    const handleOnSearchClick = () => {
        handleSearch(searchValue);
    }

    const handleOnSearchClear = () => {
        setSearchValue('');
        handleSearch('');
    }

    const handleOnSearchChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setSearchValue(e.target.value);
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        searchTimeoutRef.current = setTimeout(() => {
            searchTimeoutRef.current = undefined;
            handleSearch(e.target.value);
        }, 1000)
    }

    const handleSearch = (value: string) => {
        setTableParams({
            ...tableParams,
            search: value,
            page: 1
        });
    }

    const doNavigate = (params) => {
        history.push({ pathname: location.pathname, search: `?${getEncodedURI(params)}` });
    }

    const getReportType = (type: string) => {
        switch (type) {
            case 'activity':
                return 'Activity';
            case 'content_filter':
                return 'Content Filter';
            case 'firewall':
                return 'Firewall';
            default:
                return '';
        }
    }

    return (
        <div className="generatedReportsContainer">
            <Grid item xs={12} sm={12} md={12} lg={12} className='search-report-count topbarWidth alignTopbarItemsCenter generatedReportsMarginReset'>
                <Grid item xs={2} sm={2} md={2} lg={2} className="searchbarMaxWidth1">
                    <Box className="searchbarBox">
                        <TextField
                            id="search"
                            variant="outlined"
                            placeholder="Type something"
                            autoComplete="off"
                            size="small"
                            value={searchValue}
                            onChange={handleOnSearchChange}
                            onKeyDown={(event) => searchBoxKeyDown(event)}
                            InputLabelProps={{ className: "serachLabel" }}
                            InputProps={{
                                className: "searchbarInputs",
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {!searchValue && <SearchIcon
                                            className="searchbarIconsPosition" onClick={handleOnSearchClick}
                                        />}
                                        {searchValue && <CloseIcon
                                            className="searchbarIconsPosition"
                                            onClick={handleOnSearchClear}
                                        />}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                </Grid>
                <Grid item xs={9} sm={9} md={9} lg={9} className="generatedReportsCount">
                    Generated Reports : {total_count}
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} className="TopUsersConatiner generated-reports-table">
            <Pagination count={total_count} onPageChange={handleChangePage} page={tableParams.page} rowsPerPage={tableParams.size} onRowsPerPageChange={handleChangeSize} />

               <TableContainer className='usageReports-FleetDashboard reports-gene-container' style={{maxHeight:'320px'}}>
                             <Table aria-label='simple table' >
                               <TableHead className='tableHead-generatedReports'>
                               <TableRow className='alertReports-tableRow'>
                  {
                    HEADERS.map((header)=>{
                      return (
                        <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell new-summary-left tableHeadRow" style={{padding:'2px 16px'}}>
                        <span style={{ whiteSpace: "nowrap" }} className="align-items-center">
                         <span className="login-history-dp-name font-wt-900">{header.label}</span>
                            
                        </span>
                  </TableCell>
                      )
                    })
                  }
                 </TableRow>
                        </TableHead>
                        {reports?.length > 0 ? (
                            <TableBody className="tableBody usage-tableBody">
                                {
                                    reports && reports.map((row: GeneratedReport) =>
                                        <TableRow key={row.id} className="usageData-tabelRow config-backup-tabe-row gene-repo">
                                            <TableCell className="usagedata-tableCell config-left-align">{row.created_at ? convertDateTimeIntoTimezone(row['created_at'], authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS) : null}</TableCell>
                                            <TableCell className="usagedata-tableCell config-left-align">{row.generated_at ? convertDateTimeIntoTimezone(row['generated_at'], authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS) : null}</TableCell>
                                            <TableCell className="usagedata-tableCell config-left-align">
                                                <JsonDataTooltip data={row.filters} />
                                            </TableCell>
                                            <TableCell className="usagedata-tableCell config-left-align">
                                                <div className='generated-report-status'>
                                                    <div id={row.status === 'completed' ? 'greenDotSymbol' : row.status === 'processing' || row.status === 'queued' ? 'yellowDotSymbol' : ''}></div>
                                                    <span>{row.status}</span>
                                                </div>
                                            </TableCell>
                                            <TableCell className="usagedata-tableCell config-left-align">{getReportType(row.type)}</TableCell>
                                            <Tooltip title={row.status === 'completed' ? 'Download Summary Report' : ''}>
                                                <TableCell className={row.status === 'completed' ? "usagedata-tableCell config-left-align download-report" : "usagedata-tableCell config-left-align download-report-inProg"}
                                                    onClick={() => { row.status === 'completed' && handleDownloadReport(row, false) }}
                                                >{row.status === 'completed' ? 'Download' : 'NA'}</TableCell>
                                            </Tooltip>
                                            <Tooltip title={row.status === 'completed' && row.detailed_report_storage_path ? 'Download Flow Report' : ''}>
                                                <TableCell className={row.status === 'completed' && row.detailed_report_storage_path ? "usagedata-tableCell config-left-align download-report" : "usagedata-tableCell config-left-align download-report-inProg"}
                                                    onClick={() => { row.status === 'completed' && row.detailed_report_storage_path && handleDownloadReport(row, true) }}
                                                >{row.status === 'completed' && row.detailed_report_storage_path ? 'Download' : 'NA'}</TableCell>
                                            </Tooltip>
                                            <TableCell className="usagedata-tableCell config-left-align text-align-actions">
                                                <Tooltip title="Delete">
                                                    <IconButton size='small' onClick={() => handleDelete(row)}>
                                                        <Delete />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                        ) : (
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={6} className="noDataAvailableCss" align="center">No data available</TableCell>
                                </TableRow>
                            </TableBody>
                        )}
                    </Table>
                </TableContainer>
            </Grid>
            <DeleteReportConfirmationDialog open={toDeleteReport != null} onConfirm={handleDeleteConfirm} onCancel={handleDeleteCancel} />
        </div>
    )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    reports: state.authReducer.getGeneratedReportsTable,
    total_count: state.authReducer.getGeneratedReportsTableCount
});

export default withRouter(
    connect(mapStateToProps, {
        getGeneratedReports,
        deleteGeneratedReport,
        getGeneretedReportDownload
    })(GeneratedReports)
);